<template>
    <modal name="image-cropper-modal" :width="500" height="auto" :adaptive="true" @closed="onClosed">
        <div class="image-cropper-container">
            <h5 class="mb-3">{{ $t('imageCropper.title') }}</h5>
            <div class="image-cropper-wrapper">
                <cropper
                    ref="cropper"
                    class="image-cropper"
                    :src="imageSrc"
                    :stencil-props="{ aspectRatio: 1 }"
                    :canvas="{ maxWidth: 1024, maxHeight: 1024 }"
                />
            </div>
            <div class="d-flex justify-content-between mt-3">
                <button class="btn btn-outline-secondary" @click="cancel">{{ $t('button.cancel') }}</button>
                <button class="btn btn-primary" @click="crop" :disabled="cropping">
                    <i class="fa fa-crop-alt pr-1" v-if="!cropping"></i>
                    <i class="fas fa-cog fa-spin pr-1" v-if="cropping"></i>
                    {{ $t('imageCropper.cropAndUpload') }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { Cropper } from "vue-advanced-cropper";
    import "vue-advanced-cropper/dist/style.css";

    export default {
        name: 'ImageCropper',
        components: { Cropper },
        data: function () {
            return {
                imageSrc: null,
                resolve: null,
                cropping: false,
                mimeType: 'image/png'
            };
        },
        methods: {
            open: function (file) {
                const MAX_FILE_SIZE = 1 * 1024 * 1024;
                if (file.size > MAX_FILE_SIZE) {
                    this.$modal.cs_alert(this.$t('imageCropper.fileTooLarge'));
                    return Promise.resolve(null);
                }
                return new Promise((resolve) => {
                    this.resolve = resolve;
                    this.mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
                    this.imageSrc = URL.createObjectURL(file);
                    this.$modal.show('image-cropper-modal');
                });
            },
            crop: function () {
                this.cropping = true;
                const { canvas } = this.$refs.cropper.getResult();
                const quality = this.mimeType === 'image/jpeg' ? 0.9 : undefined;
                canvas.toBlob((blob) => {
                    if (this.resolve) this.resolve(blob);
                    this.resolve = null;
                    this.$modal.hide('image-cropper-modal');
                }, this.mimeType, quality);
            },
            cancel: function () {
                this.$modal.hide('image-cropper-modal');
            },
            onClosed: function () {
                if (this.resolve) {
                    this.resolve(null);
                    this.resolve = null;
                }
                if (this.imageSrc) {
                    URL.revokeObjectURL(this.imageSrc);
                    this.imageSrc = null;
                }
                this.cropping = false;
            }
        }
    };
</script>

<style>
    .image-cropper-container {
        padding: 20px;
    }
    .image-cropper-wrapper {
        max-height: 400px;
    }
    .image-cropper {
        max-height: 400px;
    }
</style>
